module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"my_purchase":"My Purchase","plan":"Plan","date":"Date","period":"Period","pay":"pay"},"th":{"my_purchase":"ประวัติบิล","plan":"แผน","date":"วันที่","period":"ระยะเวลา","pay":"จ่าย"}}')
  delete Component.options._Ctor
}
